export const mapToListMap = (map: { [key: string]: any }) => {
  const newMap = {}
  Object.keys(map).map(key => {
    if (Array.isArray(map[key])) {
      newMap[key] = map[key]
    } else {
      newMap[key] = [map[key]]
    }
  })
  return newMap
}

export function setDefaultIfEmpty(
  map: { [key: string]: any },
  defaults: { [key: string]: any },
) {
  if (!map) map = {}
  Object.keys(defaults).forEach(key => {
    if (!map.hasOwnProperty(key)) map[key] = defaults[key]
  })
  return map
}

export function joinListsToStr(...lists: string[][]): string {
  const ret = []
  lists.forEach(list => {
    if (list) {
      const listStr = list.filter(e => !isEmptyString(e)).join(', ')
      if (!isEmptyString(listStr)) {
        ret.push(listStr)
      }
    }
  })
  return ret.join(' / ')
}
